var exports = {
  "kL": "CollapsedCategoryVoiceParticipants.module__container___OTh1TG",
  "Kk": "CollapsedCategoryVoiceParticipants.module__icon___OTh1TG",
  "nU": "CollapsedCategoryVoiceParticipants.module__channelContainer___OTh1TG",
};

module.exports = exports;
